import React from 'react';
import { Star, ChevronDown } from 'lucide-react';
import { Card } from '../ui/Card';
import { Badge } from '../ui/Badge';
import { cn } from '../ui/Button';
interface ModelCardProps {
  name: string;
  description?: string;
  details?: string;
  color: 'pink' | 'orange' | 'blue';
  isStarred?: boolean;
  isActive?: boolean;
  isResearch?: boolean;
  initTime?: string;
}
export function ModelCard({
  name,
  description,
  details,
  color,
  isStarred,
  isActive,
  isResearch,
  initTime = 'Live'
}: ModelCardProps) {
  const colorMap = {
    pink: 'bg-[#EC4899]',
    orange: 'bg-orange-500',
    blue: 'bg-blue-500'
  };
  return <Card className={cn('p-3.5 cursor-pointer transition-all hover:bg-slate-800/50', isActive ? 'border-[#EC4899] ring-1 ring-[#EC4899]/20' : 'border-slate-800')} data-id="element-725">
      <div className="flex items-start justify-between mb-1.5" data-id="element-726">
        <div className="flex items-center gap-2" data-id="element-727">
          <span className="font-bold text-sm text-slate-100" data-id="element-728">{name}</span>
          <div className={cn('h-2.5 w-2.5 rounded-sm flex-shrink-0', colorMap[color])} data-id="element-729" />
          {isResearch && <Badge variant="pink" className="text-[9px] px-1.5 py-0 h-4" data-id="element-730">
              RESEARCH PREVIEW
            </Badge>}
        </div>
        <Star size={14} className={cn('flex-shrink-0 mt-0.5', isStarred ? 'text-[#EC4899] fill-[#EC4899]' : 'text-slate-600 hover:text-slate-400')} data-id="element-731" />
      </div>

      {description && <p className="text-xs text-slate-400 leading-relaxed mb-1.5" data-id="element-732">
          {description}
        </p>}

      {details && <p className="text-[11px] text-slate-500 mb-2.5" data-id="element-733">{details}</p>}

      <div data-id="element-734">
        <span className="text-[10px] text-slate-500 uppercase tracking-wider block mb-1" data-id="element-735">
          Initialization Time (UTC)
        </span>
        <button className="flex items-center justify-between w-full text-xs text-slate-300 bg-slate-800 px-3 py-1.5 rounded-md hover:bg-slate-700 transition-colors" data-id="element-736">
          <span data-id="element-737">{initTime}</span>
          <ChevronDown size={12} className="text-slate-500" data-id="element-738" />
        </button>
      </div>
    </Card>;
}